import io from "socket.io-client";
import { SOCKET_EVENTS } from "../../constants/textConstants";

let socket;

//
export const connectToSocket = (customerId) => {
  //REACT_APP_SERVER_URL is the Server URL for API calls
  socket = io(
    `${process.env.REACT_APP_SERVER_URL}/customer`,
    {
      transports: ["websocket"],
      query: {
        token: `Bearer ${process.env.REACT_API_TOKEN}`
      }
    });
  customerId ? initiateGoogleAssistant(customerId) : sendMessage("Hi");
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const sendMessage = (message, type) => {
  let data = {
    message,
    type: type ? type : "text",
    from: "customer",
    sentAt: Date.now(),
  };

  if (socket) {
    socket.emit(SOCKET_EVENTS.SEND_MESSAGE, data);
  }
  return data;
};


const initiateGoogleAssistant = (customerId) => {
  if (socket) {
    socket.emit(SOCKET_EVENTS.INITIATE_GOOGLE_ASSISTANT, customerId);
  }
}